import { ChangeEvent, DomEvent, EventListener, Panel } from "../..";

export enum DateTimeChangePart {
    Date = "date",
    Hour = "hour",
    Minute = "minute",
    AmPm = "ampm"
}

export interface DateTimePickerChangeListener extends EventListener<DateTimePickerChangeEvent> {
}

export class DateTimePickerChangeEvent extends ChangeEvent {
    changePart: DateTimeChangePart;
    constructor(target: Panel, oldValue: any, newValue: any, domEvent: DomEvent, changePart: DateTimeChangePart) {
        super(target, oldValue, newValue, domEvent);
        this.changePart = changePart;
    }
}
